import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';

/** Spacing Component */
@customElement('te-spacing')
export class TeSpacing extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .spacer-element {
        display: flex;
      }
    `,
  ];

  /** Size of spacing */
  @property({ type: Number }) size = 16;
  /** Direction for spacing */
  @property({ type: String }) direction: 'y' | 'x' = 'x';

  render() {
    const spacerStyle =
      this.direction === 'x' ? `min-width:${this.size}px` : `min-height: ${this.size}px`;

    return html`
      <div class="spacer-element" style="${spacerStyle}"></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-spacing': TeSpacing;
  }
}
